import React, { useContext } from "react";
import { TouchableOpacity, View, Text } from "react-native";
import { orderHistoryStyles as styles } from "./styles";
import { translateNumber, useTranslateText } from "@/app/utils/translations";
import { Order } from "@/app/types/order";
import { formatMoney } from "@/app/utils/currency";
import { TposBasketContext } from "@/app/contexts";
import { formatDate, getLineItemCount } from "@/app/utils/orderHistory";
import OrderDetailsModal from "./OrderDetailsModal";

type OrderHistoryProps = {
  order: Order;
};

const OrderHistory = ({ order }: OrderHistoryProps) => {
  const { locale, t } = useTranslateText();
  const { setOrder, selectedOrder, clearOrder } = useContext(TposBasketContext);
  const date = formatDate(order.createdAt);
  const lineItemCount = getLineItemCount(order);
  const orderNumber = translateNumber(order.albaikIdentifier, locale);
  const orderTotal = formatMoney(order?.total, true, locale).amount;
  return (
    <TouchableOpacity
      onPress={() => setOrder?.(order)}
      style={styles.container}
    >
      <Text style={styles.timeText}>{date}</Text>
      <Text style={styles.orderNumberText}>
        {`${t("orderScreen.orderNumber")} ${orderNumber}`}
      </Text>
      <Text style={styles.rowText}>{order?.branch?.name}</Text>
      <View style={styles.rowContainer}>
        <Text style={styles.rowText}>
          {`${lineItemCount} ${t("tpos.basketArea.items")}`}
        </Text>
        <Text style={styles.rowText}>{`${orderTotal}`}</Text>
      </View>
      {selectedOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          visible={selectedOrder === order}
          onClose={() => clearOrder?.()}
        />
      )}
    </TouchableOpacity>
  );
};

export default OrderHistory;
